<div class="alt">
  <p>Eğer isterseniz cümle ekleyebilirsiniz. Ancak yazılım henüz geliştirme aşamasında olduğu için bu cümlelerin silinebileceğini göz önünde bulundurunuz.
  </p>
</div>


